import { useId } from 'react';

/**
 * A stable id for pairing labels, descriptions and controls, optionally overridden by the
 * caller's own id.
 *
 * @param {string | undefined} provided -- The id the caller passed, if any.
 * @returns The id to use.
 */
export const useControlId = (provided?: string): string => {
  const generated = useId();
  return provided ?? generated;
};
